import React from 'react';
import './index.css';
import clsx from 'classnames';

const Footer = () => {
  const onClick = () => {
    window.open('https://beian.miit.gov.cn/');
  };

  return (
    <div className={clsx('footer')}>
      <div className={clsx('footer-content')}>
        <div className={clsx('footer-content__left')}>
          <img src='/img/qrcode.jpg' alt='' style={{ borderRadius: '4px' }} />
          <div className={clsx('footer-content__left-info')}>
            <div className={clsx('footer-content__left-info-company')}>
              <div>浙江之阳仪器设备有限公司</div>
              <div>
                Zhejiang Zhiyang Instrument and Equipment Manufacturing Co.,
                Ltd.
              </div>
              <div>| 专注 | 品质 | 诚信 |</div>
            </div>
          </div>
        </div>
        <div className={clsx('footer-content__right')}>
          <div className={clsx('footer-content__right-info')}>
            <div>
              服务热线：崔经理 139-8945-4782 <br />
              潘经理 138-0680-7001
            </div>
            <div>邮箱：467478893@qq.com</div>
            <div>地址：浙江省余杭区瓶窑镇崇化村嵩山头51号</div>
          </div>
        </div>
      </div>
      <div className={clsx('footer-record')}>
        <div className={clsx('footer-record__content')}>
          <div>
            Copyright © 2026 浙江之阳仪器设备有限公司All Rights Reserved
          </div>
          <div onClick={onClick}>浙ICP备20021870号-1</div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
